var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.css()},_vm._l((_vm.ratingList),function(item){
var _obj;
return _c('AtomIcon',{key:item,class:[_vm.css('item'), ( _obj = {}, _obj[_vm.css('item', 'selected')] = item === _vm.rating, _obj )],attrs:{"size":_vm.size,"data-test":"rating-item","name":"rating-star"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }